<ion-header class="ion-no-shadow ion-no-border">
    <ion-toolbar class="ion-hide-xl-up">
        <ion-title>{{ 'UNSUBSCRIBE_TITLE' | trns }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>

    <ng-container *ngIf="!loading">
        <div class="content-box">

            <div *ngIf="event"
                 class="event-detail">
                <h2> {{event.name}}</h2>
                <img img-logo
                     [src]="event.logo_url"
                     [alt]="event.name">
            </div>

            <h1>{{ 'UNSUBSCRIBE_TITLE' | trns }}</h1>

            <div class="content-box-inner">

                <div class="content-data">
                    <form method="get"
                          #f="ngForm"
                          role="form"
                          (ngSubmit)="save()"
                          class="form-horizontal">

                        <ng-container *ngIf="!send">

                            <p [innerHtml]="'UNSUBSCRIBE_TITLE_HINT' | trns"></p>
                            <br />

                            <ion-item>
                                <ion-checkbox slot="start"
                                              name="reason0"
                                              #reason0="ngModel"
                                              [(ngModel)]="reasonTypes[0]">
                                </ion-checkbox>
                                <ion-label>{{ 'UNSUBSCRIBE_REASON_1' | trns }}</ion-label>
                            </ion-item>

                            <ion-item>
                                <ion-checkbox slot="start"
                                              name="reason1"
                                              #reason1="ngModel"
                                              [(ngModel)]="reasonTypes[1]">
                                </ion-checkbox>
                                <ion-label>{{ 'UNSUBSCRIBE_REASON_2' | trns }}</ion-label>
                            </ion-item>

                            <ion-item>
                                <ion-checkbox slot="start"
                                              name="reason2"
                                              #reason2="ngModel"
                                              [(ngModel)]="reasonTypes[2]">
                                </ion-checkbox>
                                <ion-label>{{ 'UNSUBSCRIBE_REASON_3' | trns }}</ion-label>
                            </ion-item>

                            <ion-item>
                                <ion-checkbox slot="start"
                                              name="reason3"
                                              #reason3="ngModel"
                                              [(ngModel)]="reasonTypes[3]">
                                </ion-checkbox>
                                <ion-label>{{ 'UNSUBSCRIBE_REASON_4' | trns }}</ion-label>
                            </ion-item>

                            <ion-item>
                                <ion-checkbox slot="start"
                                              reasonTypes
                                              name="reason4"
                                              #reason4="ngModel"
                                              [(ngModel)]="reasonTypes[4]">
                                </ion-checkbox>
                                <ion-label>{{ 'UNSUBSCRIBE_REASON_5' | trns }}</ion-label>
                            </ion-item>

                            <ion-textarea *ngIf="reasonTypes[4]"
                                          [(ngModel)]="reason"
                                          maxLength="400"
                                          required>
                            </ion-textarea>
                        </ng-container>

                        <ng-container *ngIf="send">
                            <p [innerHtml]="'UNSUBSCRIBE_THANKS_HINT' | trns"></p>
                        </ng-container>

                        <ion-row class="options">
                            <ion-col size="12"
                                     size-md="6">
                                <ion-button *ngIf="!send"
                                            expand="block"
                                            color="primary"
                                            type="button"
                                            (click)="showFeatures()">
                                    {{ 'UNSUBSCRIBE_BUTTON_FEATURES' | trns }}
                                </ion-button>
                                <ion-button *ngIf="send"
                                            expand="block"
                                            color="secondary"
                                            type="button"
                                            (click)="contactSupport()">
                                    {{ 'UNSUBSCRIBE_BUTTON_SUPPORT' | trns }}
                                </ion-button>
                            </ion-col>

                            <ion-col size="12"
                                     size-md="1"
                                     class="or">
                                {{ 'LOGIN_OR' | trns }}
                            </ion-col>
                            <ion-col size="12"
                                     size-md="5">
                                <ion-button *ngIf="!send"
                                            expand="block"
                                            color="secondary"
                                            type="submit"
                                            [disabled]="!f.form.valid">
                                    {{ 'UNSUBSCRIBE_BUTTON' | trns }}
                                </ion-button>
                                <ion-button *ngIf="send"
                                            expand="block"
                                            color="primary"
                                            type="button"
                                            (click)="showFeatures()">
                                    {{ 'UNSUBSCRIBE_BUTTON_FEATURES_AFTER_SUBMIT' | trns }}
                                </ion-button>
                            </ion-col>
                        </ion-row>
                    </form>
                </div>
            </div>

        </div>
    </ng-container>

</ion-content>